// /videos' most-watched Shorts, videos_top_shorts (#5433; founder pick B,
// 2026-10-25). A rollout gate, not a kill switch; retire it once it is on for
// everyone (ADR 0038).
//
// The page is signed out and prerendered, so Everyone is what reaches
// visitors (a public flag, seeded into the prerendered HTML: the list is in
// the first paint). The team previews on a team device with
// ?videos_preview=1 (kept for this tab; ?videos_preview=0 ends it), or signed
// in on a listed account, the useLandingStory pattern: read after mount so
// the first render matches the prerendered markup, and never on a stranger's
// browser (isOurBrowser). The landing ribbon reads the same answer for its
// #most-watched anchor (founder answer 5).
import { useEffect, useState } from 'react';
import { isOurBrowser } from '../services/analytics';
import { useFeatureFlags } from '../context/FeatureFlagsContext';

export const TOP_SHORTS_FLAG = 'videos_top_shorts';
export const VIDEOS_PREVIEW_PARAM = 'videos_preview';
const PREVIEW_KEY = 'stratia_videos_preview';

/** Whether this tab asked for the preview, on a team device. Never throws. */
export function videosPreviewRequested() {
    try {
        const ask = new URLSearchParams(window.location.search).get(VIDEOS_PREVIEW_PARAM);
        if (ask === '1') sessionStorage.setItem(PREVIEW_KEY, '1');
        if (ask === '0') sessionStorage.removeItem(PREVIEW_KEY);
        return sessionStorage.getItem(PREVIEW_KEY) === '1' && isOurBrowser();
    } catch {
        return false;
    }
}

/** Pure: on for everyone, for a listed account signed in, or in a team preview. */
export function topShortsOn({ publicFlags, flags, preview = false }) {
    return Boolean(publicFlags?.[TOP_SHORTS_FLAG]) || Boolean(flags?.[TOP_SHORTS_FLAG]) || Boolean(preview);
}

/** The page's answer: the public flag at once; the account and the preview after mount. */
export default function useTopShortsFlag() {
    const { publicFlags, flags } = useFeatureFlags({ mine: true, public: true }) || {};
    const [preview, setPreview] = useState(false);
    useEffect(() => { setPreview(videosPreviewRequested()); }, []);
    return topShortsOn({ publicFlags, flags, preview });
}
